/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "18ee0dd2589db11ba93d12ae75e51b6af7a43556";
